import React from 'react';
import { shape, func, arrayOf } from 'prop-types';
import Box from '@material-ui/core/Box';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import LocationOn from '@material-ui/icons/LocationOn';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  list: {
    position: 'absolute',
    display: 'block',
    zIndex: 2,
    width: 'calc(100vw - 32px)',
    maxWidth: 500,
    boxShadow: theme.shadows[4],
    padding: 0,
    margin: 'auto',
    backgroundColor: theme.palette.neutral.lightest,
    [theme.breakpoints.up('sm')]: {
      width: 500,
    },
  },
  listIcon: {
    minWidth: theme.spacing(4),
  },
  item: {
    cursor: 'pointer',
    margin: theme.spacing(2, 0),
    backgroundColor: theme.palette.neutral.lightest,
    [theme.breakpoints.up('md')]: {
      margin: 0,
    },
  },
  listText: {
    display: 'block',
    whiteSpace: 'nowrap',
  },
  selected: {
    color: theme.palette.secondary.main,
    width: '100%',
    left: 0,
    [theme.breakpoints.up('md')]: {
      width: 'unset',
    },
  },
}));

const FilteredSuggestions = ({ filteredSuggestions, getSuggestionItemProps }) => {
  const classes = useStyles();

  return (
    <Box justifyContent={{ xs: 'center', sm: 'unset' }} display={{ xs: 'flex', sm: 'unset' }}>
      <List className={classes.list} data-testid="location-autocomplete">
        {filteredSuggestions.map((suggestion, i) => (
          <ListItem
            id={`filtered-suggestion-${i}`}
            {...getSuggestionItemProps(suggestion, {
              classes: {
                root: classes.item,
                selected: classes.selected,
              },
            })}
            divider
            selected={suggestion.active}
            key={suggestion.placeId}
          >
            <ListItemIcon className={classes.listIcon}>
              <LocationOn />
            </ListItemIcon>
            <ListItemText
              primary={suggestion.description}
              primaryTypographyProps={{
                variant: 'body2',
                noWrap: true,
                classes: {
                  root: classes.listText,
                },
              }}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

FilteredSuggestions.propTypes = {
  getSuggestionItemProps: func.isRequired,
  filteredSuggestions: arrayOf(shape({})).isRequired,
};
export default FilteredSuggestions;
